import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'

import {
  isFilterVisible,
  T_Filter,
  useFiltersStore,
} from '../state/filtersStore'

export const useVisibleFilters = (): T_Filter[] => {
  const { filters, appliedFilters } = useFiltersStore(
    useShallow((s) => ({
      filters: s.filters,
      appliedFilters: s.appliedFilters,
    }))
  )

  return useMemo(
    () =>
      filters.filter(
        (f) => f.show_in_guide && isFilterVisible(f, appliedFilters)
      ),
    [filters, appliedFilters]
  )
}

export const useSelectedVisibleIndex = (): number => {
  const { selectedFilter } = useFiltersStore(
    useShallow((s) => ({ selectedFilter: s.selectedFilter }))
  )
  const visible = useVisibleFilters()
  return useMemo(
    () =>
      selectedFilter
        ? visible.findIndex((f) => f.acf_name === selectedFilter.acf_name)
        : -1,
    [visible, selectedFilter]
  )
}
